var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('b-loading',{attrs:{"active":_vm.state.loading}}),_c('ShareCampaignPageContents',{attrs:{"campaign":_vm.state.campaign,"master":_vm.master,"got-stamp":_vm.state.gotStamp},on:{"click:share":_vm.share}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }